import React from 'react';
import { Reveal } from './ui/Reveal';
import { CARELIZ_PORTRAIT } from '../data/site';
export function StorySection() {
  return <section className="bg-ivory px-6 py-20 sm:py-28" data-id="element-298" data-mp="gz4suw2zf5bc">
      <div className="mx-auto grid max-w-5xl items-start gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-299" data-mp="c1bma1xro9aj">
        <Reveal data-id="element-300" data-mp="80jcn7kzg2dq">
          <div className="relative mx-auto max-w-xs lg:max-w-none" data-id="element-301" data-mp="811841ztmckl">
            <div className="absolute -inset-2.5 rounded-[1.75rem] border border-gold/35" data-id="element-302" data-mp="14q0hjkc55ked" />
            <img src={CARELIZ_PORTRAIT} alt="Careliz Griman" className="relative w-full rounded-[1.5rem] object-cover shadow-lift" data-id="element-303" data-mp="zr5yqie6bvu9" />
          </div>
          <div className="mt-7 text-center lg:text-left" data-id="element-304" data-mp="qqhhzfxebhdo">
            <p className="font-script text-4xl text-gold-dark" data-id="element-305" data-mp="qpzj0bjcmp22">Careliz Griman</p>
            <p className="mt-2 text-[10px] font-semibold uppercase tracking-[0.26em] text-ink-muted" data-id="element-306" data-mp="3ggkwamlmx4ss">
              Coach · Mentora · Speaker
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-307" data-mp="1o8r73am4eupt">
          <h2 className="font-serif text-[1.75rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-308" data-mp="1o8hedf9oy9gf">
            Yo también <em className="not-italic text-gold-dark" data-id="element-309" data-mp="1t4olvchqjt0h">estuve ahí.</em>
          </h2>

          <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-[18.5px]" data-id="element-310" data-mp="1f6qamfypocp7">
            <p data-id="element-311" data-mp="1k49p9gzbmrho">
              Hubo un momento de mi vida en el que me miré al espejo y no me
              reconocía.
            </p>
            <p className="font-serif text-lg italic leading-relaxed text-ink sm:text-xl" data-id="element-312" data-mp="1a7wyaqv5urqm">
              Había dejado de confiar en mí.
              <br data-id="element-313" data-mp="whjn8fmz2wx2" />
              Había dejado de brillar.
              <br data-id="element-314" data-mp="10i3mppv0qcmd" />
              Había dejado de soñar como antes.
            </p>
            <p data-id="element-315" data-mp="10fr55dt6a49u">
              Y aunque por fuera seguía adelante, por dentro sabía que algo
              necesitaba cambiar.
            </p>
            <p data-id="element-316" data-mp="rhowqd7409cj">
              Fue entonces cuando comencé un proceso profundo de formación,
              autoconocimiento y reconexión conmigo misma. Comencé a trabajar en
              mi seguridad, mi voz, mi propósito y la manera en que estaba
              viviendo mi propia vida.
            </p>
          </div>

          <figure className="mt-9 border-l-2 border-gold/50 pl-6" data-id="element-317" data-mp="2kf2m56bgiqej">
            <blockquote className="font-serif text-xl font-light leading-snug text-ink sm:text-2xl" data-id="element-318" data-mp="2ffq02nsetnd0">
              Y descubrí algo que cambió mi manera de verme:{' '}
              <em className="not-italic text-gold-dark" data-id="element-319" data-mp="3c34fqiq8pg9z">
                la transformación exterior comienza con una conversación
                interior.
              </em>
            </blockquote>
          </figure>

          <div className="mt-9 space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-[18.5px]" data-id="element-320" data-mp="2y5xzauszntnx">
            <p data-id="element-321" data-mp="1rpc7mw5wxmhw">
              Hoy acompaño a mujeres que también sienten que están listas para
              una nueva etapa.
            </p>
            <p data-id="element-322" data-mp="1mpr8olqqte56">
              No desde la perfección. Sino desde mi propia experiencia,
              formación y proceso.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}